import { render, staticRenderFns } from "./SimulationSelector.vue?vue&type=template&id=2b3d7bdb&scoped=true&"
import script from "./SimulationSelector.vue?vue&type=script&lang=js&"
export * from "./SimulationSelector.vue?vue&type=script&lang=js&"
import style0 from "./SimulationSelector.vue?vue&type=style&index=0&id=2b3d7bdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d7bdb",
  null
  
)

export default component.exports